<template>
  <div class="page-breadcrumb">
    <div class="page-title">
      <div class="row">
        <div class="col-5 align-self-center">
          <h4 class="mb-0">{{ title }}</h4>
        </div>
        <div class="col-7 align-self-center">
          <div class="d-flex align-items-center justify-content-end">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/dashboard"><vue-feather type="home" size="15px" /></router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page" v-if="main">
                  <router-link :to="mainRoute || '/dashboard'">{{ main }}</router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page" v-if="parentTitle">
                  <span>{{ parentTitle }}</span>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  <router-link v-if="titleRoute" :to="titleRoute">{{ title }}</router-link>
                  <span v-else>{{ title }}</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    title: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    parentTitle: {
      type: String,
      default: ''
    },
    mainRoute: {
      type: [String, Object],
      default: '/dashboard'
    },
    titleRoute: {
      type: [String, Object],
      default: null
    }
  }
}
</script>

<style scoped>
.page-title h3 {
  text-transform: none !important;
}

.breadcrumb-item a {
  color: var(--theme-default);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-item a:hover {
  color: var(--theme-deafult);
  text-decoration: underline;
}

.breadcrumb-item.active {
  font-weight: 500;
}

/* Add some spacing for better visual hierarchy */
.breadcrumb-item:not(:last-child)::after {
  content: '';
  margin: 0 8px;
  color: #6c757d;
}
</style>